"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseToken = exports.getWrappedBaseToken = void 0;
const shared_models_1 = require("@railgun-community/shared-models");
const getWrappedBaseToken = (networkName) => {
    const network = shared_models_1.NETWORK_CONFIG[networkName];
    if (!(0, shared_models_1.isDefined)(network)) {
        throw new Error(`Unknown network: ${networkName}`);
    }
    return {
        tokenAddress: network.baseToken.wrappedAddress.toLowerCase(),
        decimals: BigInt(network.baseToken.decimals),
        isBaseToken: false,
    };
};
exports.getWrappedBaseToken = getWrappedBaseToken;
const getBaseToken = (networkName) => {
    return {
        ...(0, exports.getWrappedBaseToken)(networkName),
        isBaseToken: true,
    };
};
exports.getBaseToken = getBaseToken;
